module.exports = __webpack_public_path__ + "img/link07.bcc5bf46.png";